import React from 'react';
import { TextStyle } from '@superops/ui-design-system';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';

function MoreInfoTextCell(props: { cell: { value: string } }) {
  const { cell } = props;

  const value = {
    SUPPORTED: 'Supported',
    NOT_SUPPORTED: 'Not Supported'
  };

  return (
    <div className="flex">
      {cell.value ? (
        <TextStyle>{value[cell?.value] || cell.value}</TextStyle>
      ) : (
        <DisabledTag>NA</DisabledTag>
      )}
    </div>
  );
}

export default MoreInfoTextCell;
